'use client';

import { IconSlidersHorizontal } from '@/components/icons/IconSlidersHorizontal';
import { useInView } from '@/hooks';
import { cn } from '@/lib/utils/tw-merge';

type VehicleFilterButtonProps = {
    activeCount: number;
    expanded: boolean;
    controls: string;
    onOpen: () => void;
};

/** Floating „Filter“ button below md. It steps aside for the open drawer and the footer. */
export function VehicleFilterButton({ activeCount, expanded, controls, onOpen }: VehicleFilterButtonProps) {
    const footerInView = useInView('.site-footer');

    return (
        <button
            type="button"
            className={cn('vehicle-filter-fab label-md', (expanded || footerInView) && 'vehicle-filter-fab--hidden')}
            aria-haspopup="dialog"
            aria-expanded={expanded}
            aria-controls={controls}
            onClick={onOpen}
        >
            <IconSlidersHorizontal width={18} height={18} aria-hidden="true" />
            Filter
            {activeCount > 0 ? (
                <span className="vehicle-filter-fab__count label-xs">
                    {activeCount}
                    <span className="sr-only"> aktiv</span>
                </span>
            ) : null}
        </button>
    );
}
